import { render } from "./UserAdministratorCard.vue?vue&type=template&id=4ececada"
import script from "./UserAdministratorCard.vue?vue&type=script&lang=js"
export * from "./UserAdministratorCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__